module.exports = __webpack_public_path__ + "img/icon_panorama_loading_img.b824a745.gif";